import i18n, { translate as tr } from "../../i18n";
import { withTranslation, Trans } from "react-i18next";
import LanguageSelector from "../common/LanguageSelector";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { register, loadUser } from "../../actions/auth";
import "../../assets/css/auth.css";
import { BlackLogo } from "../common/BlackLogo";
import { bindActionCreators } from "redux";
import Alert from "../common/Alert";
import { Navigate, NavLink } from "react-router-dom";
import GoogleSignInButton from "../common/GoogleSignInButton";
import scriptjs from "scriptjs";
import { setInvite, removeInvite } from "../../actions/invite_ids";
import { setAlert } from "../../actions/alert";
import { motion, AnimatePresence } from "framer-motion";
import CanvasRevealEffect from "../common/CanvasRevealEffect";
import { generatePassword } from "../../utils/password";
import { trackPlausibleEvent } from "../../utils/plausible";

// Sign in with Apple is off until the Apple Services ID is set up again; build with REACT_APP_APPLE_SIGNIN=true to show it
const APPLE_SIGNIN_ENABLED = process.env.REACT_APP_APPLE_SIGNIN === "true";

export class Register extends React.Component {
  handleLanguageChange = () => this.forceUpdate();
  componentWillUnmount() { i18n.off("languageChanged", this.handleLanguageChange); }

  constructor(props) {
    super(props);
    this.state = {
      email: "", password: "", passwordConfirmation: "",
      first_name: "", last_name: "", country: "",
      consent: false,
      errors: {}, hidden: true, hiddenConfirm: true, isAuthenticated: false,
      workspace_id: 0, invite_id: 0,
      submitted: false, registeredEmail: "",
      password_check: { length: false, number: false, letter: false, special: false },
      serverError: "",
    };
  }

  componentDidMount() {
    i18n.on("languageChanged", this.handleLanguageChange);
    trackPlausibleEvent("Register Page Viewed");
    this.checkUser();
    this.checkApple();
    if (APPLE_SIGNIN_ENABLED) scriptjs.get("https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js", () => {
      const params = {
        clientId: process.env.REACT_APP_APPLE_CLIENT_ID || "minutezilla.com",
        redirectURI: "https://app.minutezilla.com/api/apple/verify",
        scope: "name email",
      };
      window.AppleID.auth.init(params);
    });
  }

  signup = async (res) => {
    try {
      const fullName   = res.name || "";
      const first_name = res.given_name  || fullName.split(" ")[0] || "";
      const last_name  = res.family_name || fullName.split(" ").slice(1).join(" ") || first_name || "";
      const config     = { headers: { Accept: "application/json", "Content-Type": "application/json" } };
      let password = generatePassword({ length: 10, numbers: true });
      let { workspace_id, invite_id } = this.state;
      const body = JSON.stringify({ email: res.email, first_name, last_name, password, workspace_id, invite_id });
      let res1 = await axios.post("/api/google/signup", body, config);
      if (res1.status === 200 && res1.data.confirmation === true) {
        await this.props.loadUser(res1);
        await this.props.removeInvite();
        trackPlausibleEvent("Signup Completed", { method: "google" });
        this.setState({ isAuthenticated: true });
      }
    } catch (error) {
      console.log(error);
      trackPlausibleEvent("Signup Failed", {
        method: "google",
        reason: error?.response?.data?.errors?.[0]?.msg || error?.message || "unknown",
      });
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) errors.forEach((e) => this.props.setAlert(e.msg, "danger"));
      }
    }
  };

  checkUser = async () => {
    let url = new URL(window.location.href);
    let c = url.searchParams.get("data");
    if (c) {
      let data = atob(c).split(" ");
      await this.props.setInvite(data[2], data[0]);
      this.setState({ email: data[1], workspace_id: data[0], invite_id: data[2] });
    }
  };

  checkApple = async () => {
    try {
      let url = new URL(window.location.href);
      if (url.searchParams.get("apple_error")) {
        this.props.setAlert("Sign in with Apple failed, please try again", "danger");
      }
      let apple_token = url.searchParams.get("apple_token");
      if (apple_token) {
        window.history.replaceState(null, "", window.location.pathname);
        const config = { headers: { Accept: "application/json", "Content-Type": "application/json" } };
        let password = generatePassword({ length: 10, numbers: true });
        let workspace_id, invite_id;
        if (this.props.invite_ids.payload !== undefined && this.props.invite_ids.payload !== null && this.props.invite_ids.payload !== "") {
          workspace_id = this.props.invite_ids.payload.invite_wid;
          invite_id    = this.props.invite_ids.payload.invite_id;
        } else {
          workspace_id = this.props.invite_ids.invite_wid;
          invite_id    = this.props.invite_ids.invite_id;
        }
        const body = JSON.stringify({ apple_token, password, workspace_id, invite_id });
        let res1 = await axios.post("/api/apple/user", body, config);
        if (res1.status === 200 && res1.data.confirmation === true) {
          await this.props.loadUser(res1);
          await this.props.removeInvite();
          trackPlausibleEvent("Signup Completed", { method: "apple" });
          this.setState({ isAuthenticated: true });
        }
      }
    } catch (error) {
      console.log(error);
      trackPlausibleEvent("Signup Failed", {
        method: "apple",
        reason: error?.response?.data?.errors?.[0]?.msg || error?.message || "unknown",
      });
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) errors.forEach((e) => this.props.setAlert(e.msg, "danger"));
      }
    }
  };

  handleChange      = (e) => this.setState({ [e.target.name]: e.target.value, errors: {} });
  toggleShow        = () => this.setState({ hidden:        !this.state.hidden });
  toggleShowConfirm = () => this.setState({ hiddenConfirm: !this.state.hiddenConfirm });

  validateForm() {
    let { email, password, passwordConfirmation, first_name, last_name, consent } = this.state;
    let errors = {}, formIsValid = true;
    if (!first_name)  { formIsValid = false; errors.first_name = "auth_first_name_is_required"; }
    if (!last_name)   { formIsValid = false; errors.last_name  = "auth_last_name_is_required"; }
    if (!email)       { formIsValid = false; errors.email = "auth_email_address_is_required"; }
    if (email) {
      const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
      if (!pattern.test(email)) { formIsValid = false; errors.email = "auth_please_enter_a_valid_email_address"; }
    }
    if (!password)                    { formIsValid = false; errors.password = "auth_password_is_required"; }
    if (password && password.length < 8)      { formIsValid = false; errors.password = "auth_password_must_be_at_least_8_characters"; }
    if (password && !/[A-Z]/.test(password))  { formIsValid = false; errors.password = "auth_password_must_include_at_least_one_uppercase_letter"; }
    if (password && !/[0-9]/.test(password))  { formIsValid = false; errors.password = "auth_password_must_include_at_least_one_number"; }
    if (password && passwordConfirmation && password !== passwordConfirmation) {
      formIsValid = false; errors.passwordConfirmation = "auth_passwords_do_not_match";
    }
    if (!passwordConfirmation) { formIsValid = false; errors.passwordConfirmation = "auth_please_confirm_your_password"; }
    if (!consent) { formIsValid = false; errors.consent = "auth_you_must_agree_to_the_terms_of_service_and_privacy_policy"; }
    this.setState({ errors });
    return formIsValid;
  }

  registerUser = async (e) => {
    e.preventDefault();
    this.setState({ serverError: "" });
    try {
      if (this.validateForm()) {
        let { email, password, first_name, last_name, workspace_id, invite_id } = this.state;
        trackPlausibleEvent("Signup Started", { method: "password" });
        const sentTo = email;
        let result = await this.props.register({ first_name, last_name, email, password, workspace_id, invite_id });
        if (result === 1) {
          trackPlausibleEvent("Signup Confirmation Sent", { method: "password" });
          this.setState({
            email: "", password: "", passwordConfirmation: "",
            first_name: "", last_name: "", country: "", consent: false,
            errors: {}, hidden: true, hiddenConfirm: true, isAuthenticated: false,
            workspace_id: 0, invite_id: 0,
            password_check: { length: false, number: false, letter: false, special: false },
            submitted: true, registeredEmail: sentTo, serverError: "",
          });
        } else if (result?.error) {
          this.setState({ serverError: result.error });
        } else {
          this.setState({ isAuthenticated: true });
        }
      } else {
        trackPlausibleEvent("Signup Failed", { method: "password", reason: "validation" });
      }
    } catch (err) {
      console.log(err);
    }
  };

  resendEmail = async () => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      await axios.post("/api/register/resend", JSON.stringify({ email: this.state.registeredEmail }), config);
      trackPlausibleEvent("Signup Confirmation Resent", { method: "password" });
      this.props.setAlert(this.props.t("auth_verification_email_resent_please_check_your_inbox"), "success");
    } catch (err) {
      this.props.setAlert(this.props.t("auth_could_not_resend_email_please_try_again"), "danger");
    }
  };

  checkPassword = () => {
    let p = this.state.password;
    this.setState({
      password_check: {
        length:  p.length > 8,
        letter:  /[a-z]/.test(p) && /[A-Z]/.test(p),
        number:  /[0-9]/.test(p),
        special: /[!@#$]/.test(p),
      },
    });
  };

  hanldeKeydown = (e) => { if (e.keyCode === 13) { e.preventDefault(); this.registerUser(e); } };

  render() {
    const responseGoogle = (profile) => { if (profile && profile.email) this.signup(profile); };
    const googleError = (error) => {
      const message =
        error?.message ||
        error?.error_description ||
        error?.details ||
        this.props.t("auth_google_sign_up_could_not_be_completed_please_try_again");
      this.props.setAlert(message, "danger");
    };
    if (this.state.isAuthenticated) return <Navigate to="/dashboard" replace />;

    const { errors, hidden, hiddenConfirm, password_check, submitted, registeredEmail, serverError } = this.state;

    return (
      <div className="auth-root">

        {/* ── Left Panel — dark brand side with animated dots ── */}
        <div className="auth-left">
          {/* WebGL dot-matrix canvas — sits behind all content */}
          <div style={{ position: "absolute", inset: 0, zIndex: 0 }}>
            <CanvasRevealEffect
              animationSpeed={3}
              colors={[[255, 255, 255], [255, 255, 255]]}
              dotSize={4}
              opacities={[0.04, 0.04, 0.06, 0.08, 0.1, 0.12, 0.16, 0.2, 0.25, 0.3]}
              showGradient={false}
              reverse={false}
            />
          </div>

          <div className="auth-logo">
            <BlackLogo />
          </div>

          <div className="auth-hero">
            <div className="auth-hero-badge">
              <span className="auth-hero-badge-dot"></span>{this.props.t("auth_free_forever_plan_available")}</div>
            <h1><Trans i18nKey="registerHero" components={{ strong: <span /> }} /></h1>
            <p>{this.props.t("auth_join_teams_who_use_minutezilla_to_understand_where_their_time_goes_and_make_every_hour_count")}</p>

            <div className="auth-features">
              <div className="auth-feature-item">
                <div className="auth-feature-icon">
                  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span className="auth-feature-text">{this.props.t("auth_no_credit_card_required")}</span>
              </div>
              <div className="auth-feature-item">
                <div className="auth-feature-icon">
                  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span className="auth-feature-text">{this.props.t("auth_unlimited_time_entries_on_free_plan")}</span>
              </div>
              <div className="auth-feature-item">
                <div className="auth-feature-icon">
                  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span className="auth-feature-text">{this.props.t("auth_invite_your_team_in_minutes")}</span>
              </div>
              <div className="auth-feature-item">
                <div className="auth-feature-icon">
                  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span className="auth-feature-text">{this.props.t("auth_google_apple_sign_in_supported")}</span>
              </div>
            </div>
          </div>

          <div className="auth-stats">
            <div className="auth-stat-item">
              <div className="auth-stat-value">{tr("2 min")}</div>
              <div className="auth-stat-label">{this.props.t("auth_to_set_up")}</div>
            </div>
            <div className="auth-stat-item">
              <div className="auth-stat-value">100%</div>
              <div className="auth-stat-label">{this.props.t("auth_free_to_start")}</div>
            </div>
            <div className="auth-stat-item">
              <div className="auth-stat-value">∞</div>
              <div className="auth-stat-label">{this.props.t("auth_time_entries")}</div>
            </div>
          </div>
        </div>

        {/* ── Right Panel — light form area ── */}
        <div className="auth-right">
          <motion.div
            className="auth-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, ease: "easeOut" }}
          >
            <LanguageSelector />
            <AnimatePresence exitBeforeEnter>
              {submitted ? (
                /* ── Email confirmation state ── */
                <motion.div
                  key="success"
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -16 }}
                  transition={{ duration: 0.35, ease: "easeOut" }}
                >
                  <div className="auth-success-box">
                    <div className="auth-success-icon">
                      <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                    <div className="auth-success-text">
                      <h4>{this.props.t("auth_check_your_inbox")}</h4>
                      <p><Trans i18nKey="confirmation" values={{ email: registeredEmail }} components={{ strong: <strong /> }} /></p>
                      <button
                        onClick={this.resendEmail}
                        style={{ background: "none", border: "none", color: "#1a5c30", fontWeight: 600, cursor: "pointer", padding: 0, fontSize: 13, marginTop: 8 }}
                      >{this.props.t("auth_didn_t_receive_it_resend_email")}</button>
                    </div>
                  </div>
                  <p className="auth-footer-link" style={{ marginTop: 20 }}>{this.props.t("auth_wrong_email")}<NavLink to="/">{this.props.t("auth_start_over")}</NavLink>
                  </p>
                </motion.div>
              ) : (
                /* ── Registration form ── */
                <motion.div
                  key="form"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.25 }}
                >
                  <div className="auth-card-header">
                    <h2>{this.props.t("auth_create_your_account")}</h2>
                    <p>{this.props.t("auth_start_tracking_your_time_for_free_no_credit_card_needed")}</p>
                  </div>

                  {/* Social */}
                  <div className="auth-social-row">
                    <GoogleSignInButton
                      className="auth-social-btn auth-btn-google"
                      onSuccess={responseGoogle}
                      onError={googleError}
                    >
                      <svg viewBox="0 0 24 24">
                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                      </svg>{this.props.t("auth_sign_up_with_google")}</GoogleSignInButton>

                    {APPLE_SIGNIN_ENABLED && (
                      <button className="auth-social-btn auth-btn-apple" onClick={() => window.AppleID && window.AppleID.auth.signIn()}>
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.39-1.32 2.76-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                        </svg>{this.props.t("auth_sign_up_with_apple")}</button>

                    )}
                  </div>

                  <div className="auth-divider">{this.props.t("auth_or_sign_up_with_email")}</div>

                  {serverError && (
                    <div className="auth-inline-error">
                      {serverError.toLowerCase().includes("already exists") ? (
                        <>{this.props.t("auth_an_account_with_this_email_already_exists")}{" "}<NavLink to="/login">{this.props.t("auth_sign_in_instead")}</NavLink></>
                      ) : serverError}
                    </div>
                  )}

                  <div className="auth-alert-wrap"><Alert /></div>

                  <form className="auth-form" onSubmit={this.registerUser} noValidate>
                    <div className="auth-field-row">
                      <div className="auth-field">
                        <label className="auth-label" htmlFor="first_name">{this.props.t("auth_first_name")}</label>
                        <input
                          className={`auth-input${errors.first_name ? " is-error" : ""}`}
                          type="text" id="first_name" name="first_name"
                          placeholder={this.props.t("auth_john")}
                          value={this.state.first_name}
                          onChange={this.handleChange}
                          onKeyDown={this.hanldeKeydown}
                          autoCorrect="off" autoCapitalize="off" spellCheck="false"
                        />
                        {errors.first_name && <span className="auth-error-msg">{this.props.t(errors.first_name)}</span>}
                      </div>
                      <div className="auth-field">
                        <label className="auth-label" htmlFor="last_name">{this.props.t("auth_last_name")}</label>
                        <input
                          className={`auth-input${errors.last_name ? " is-error" : ""}`}
                          type="text" id="last_name" name="last_name"
                          placeholder={this.props.t("auth_doe")}
                          value={this.state.last_name}
                          onChange={this.handleChange}
                          onKeyDown={this.hanldeKeydown}
                          autoCorrect="off" autoCapitalize="off" spellCheck="false"
                        />
                        {errors.last_name && <span className="auth-error-msg">{this.props.t(errors.last_name)}</span>}
                      </div>
                    </div>

                    <div className="auth-field">
                      <label className="auth-label" htmlFor="reg-email">{this.props.t("auth_email_address")}</label>
                      <input
                        className={`auth-input${errors.email ? " is-error" : ""}`}
                        type="email" id="reg-email" name="email"
                        placeholder={this.props.t("auth_you_example_com")}
                        value={this.state.email}
                        onChange={this.handleChange}
                        onKeyDown={this.hanldeKeydown}
                        autoCorrect="off" autoCapitalize="off" spellCheck="false"
                        autoComplete="email"
                      />
                      {errors.email && <span className="auth-error-msg">{this.props.t(errors.email)}</span>}
                    </div>

                    <div className="auth-field">
                      <label className="auth-label" htmlFor="reg-password">{this.props.t("auth_password")}</label>
                      <div className="auth-input-wrap">
                        <input
                          className={`auth-input auth-input-with-toggle${errors.password ? " is-error" : ""}`}
                          type={hidden ? "password" : "text"}
                          id="reg-password" name="password"
                          placeholder={this.props.t("auth_min_8_characters")}
                          value={this.state.password}
                          onChange={this.handleChange}
                          onKeyUp={this.checkPassword}
                          onKeyDown={this.hanldeKeydown}
                          autoComplete="new-password"
                        />
                        <button type="button" className="auth-input-toggle" onClick={this.toggleShow} aria-label={this.props.t(hidden ? tr("showPassword") : tr("hidePassword"))}>
                          {hidden ? (
                            <svg viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                          ) : (
                            <svg viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                          )}
                        </button>
                      </div>
                      {errors.password && <span className="auth-error-msg">{this.props.t(errors.password)}</span>}
                      <div className="auth-pw-check">
                        <span className={`auth-pw-pill${password_check.length  ? " active" : ""}`}>{this.props.t("auth_8_chars")}</span>
                        <span className={`auth-pw-pill${password_check.letter  ? " active" : ""}`}>{this.props.t("auth_uppercase")}</span>
                        <span className={`auth-pw-pill${password_check.number  ? " active" : ""}`}>{this.props.t("auth_number")}</span>
                        <span className={`auth-pw-pill${password_check.special ? " active" : ""}`}>{this.props.t("auth_special")}</span>
                      </div>
                    </div>

                    <div className="auth-field">
                      <label className="auth-label" htmlFor="reg-password-confirm">{this.props.t("auth_confirm_password")}</label>
                      <div className="auth-input-wrap">
                        <input
                          className={`auth-input auth-input-with-toggle${errors.passwordConfirmation ? " is-error" : ""}`}
                          type={hiddenConfirm ? "password" : "text"}
                          id="reg-password-confirm" name="passwordConfirmation"
                          placeholder={this.props.t("auth_re_enter_your_password")}
                          value={this.state.passwordConfirmation}
                          onChange={this.handleChange}
                          onKeyDown={this.hanldeKeydown}
                          autoComplete="new-password"
                        />
                        <button type="button" className="auth-input-toggle" onClick={this.toggleShowConfirm} aria-label={this.props.t(hiddenConfirm ? tr("showPassword") : tr("hidePassword"))}>
                          {hiddenConfirm ? (
                            <svg viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                          ) : (
                            <svg viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                          )}
                        </button>
                      </div>
                      {errors.passwordConfirmation && <span className="auth-error-msg">{this.props.t(errors.passwordConfirmation)}</span>}
                    </div>

                    <div className="auth-consent">
                      <label className={`auth-consent-label${errors.consent ? " is-error" : ""}`}>
                        <input
                          type="checkbox"
                          className="auth-consent-checkbox"
                          checked={this.state.consent}
                          onChange={(e) => this.setState({ consent: e.target.checked, errors: { ...this.state.errors, consent: null } })}
                        />
                        <span>
                          {this.props.t("auth_i_agree_to_the")}{" "}
                          <a href="/agb" target="_blank" rel="noopener noreferrer">{this.props.t("auth_terms_of_service")}</a>
                          {" "}{this.props.t("auth_and")}{" "}
                          <a href="/datenschutz" target="_blank" rel="noopener noreferrer">{this.props.t("auth_privacy_policy")}</a>
                        </span>
                      </label>
                      {errors.consent && <span className="auth-error-msg">{this.props.t(errors.consent)}</span>}
                    </div>

                    <button type="button" className="auth-submit-btn" onClick={this.registerUser}>{this.props.t("auth_create_free_account")}</button>
                  </form>

                  <p className="auth-footer-link">{this.props.t("auth_already_have_an_account")}<NavLink to="/login">{this.props.t("auth_sign_in")}</NavLink>
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        </div>

      </div>
    );
  }
}

Register.propTypes = {
  register: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({ invite_ids: state.invite_ids });
const mapDispatchToProps = (dispatch) => bindActionCreators({ register, loadUser, setInvite, removeInvite, setAlert }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Register));
